/* eslint-disable react/prop-types */
/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
/*import { ArrayExtensions, ObjectExtensions } from '@msdyn365-commerce-modules/retail-actions';*/
/*import { Module, Node } from '@msdyn365-commerce-modules/utilities';*/
import * as React from 'react';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import { ILobasProductAttributeViewProps } from './lobas-product-attribute';
import { ArrayExtensions } from '@msdyn365-commerce-modules/retail-actions';

const LobasProductAttributeView: React.FC<ILobasProductAttributeViewProps> = props =>
    ArrayExtensions.hasElements(props.attribute) && props.attribute[0] !== null ? (
        <Module {...props.ProductAttribute}>
            {(props.attribute[0]?.props.dangerouslySetInnerHTML !== undefined ||
                (ArrayExtensions.hasElements(props.attribute[0]?.props.children) &&
                    props.attribute[0]?.props.children[0].props.dangerouslySetInnerHTML !== undefined)) &&
                props.title}
            <Node className={'lobas-product-attribute__text'}>{props.attribute}</Node>
        </Module>
    ) : (
        <></>
    );
/*<div className={props.className} id={props.id} {...props.renderModuleAttributes(props)}>
    {props.attribute}
</div>*/

export default LobasProductAttributeView;
